import { IconAtom2 } from "../atoms/iconAtom";
import { InputForm } from "../atoms/input";
import { icon } from "../functions/icons";

export function ChatInputField({ value, inputChange, enterPressed, files, removeFile }) {
    return (
        <div 
            style={{ "boxSizing": "border-box" }} 
            className="standard-margin-left vertical standard-shadow standard-border standard-rounded">
            {files.length > 0 && <div className="horizontal standard-small-margin-top" style={{"flexWrap": "wrap"}}>
                {files.map((file) => (
                    <div key={file.name} onClick={() => removeFile(file.name)} className="standard-margin-right standard-small-margin-bottom file-box horizontal">
                        <div className="standard-margin-right">
                            {["png","jpg","webp","jpeg","js"].includes(file.name.split(".")[file.name.split(".").length - 1]) ? icon("photo") : icon("file")}
                        </div>
                        <div className="standard-margin-right">
                            <p className="grey-900 small-text" style={{"fontWeight": "600"}}>{file.name}</p>
                            <p className="grey-700" style={{"fontSize": "10px"}}>{(file.size / (1024*1024)).toFixed(1).replace(".", ",")} MB</p>
                        </div>
                        <div>
                            {icon("trash")}
                        </div>
                    </div>
                ))}
            </div> }
            <div className="horizontal">
                <input 
                    type="text"
                    placeholder="Type een bericht..."
                    className="hidden-text-input"
                    onKeyDown={(e) => e.key === 'Enter' && enterPressed()}
                    onChange={(e) => inputChange(e.target.value)}
                    value={value}
                    style={{"padding": "0.75rem 1rem"}}
                />
            </div>
            
        </div>
    );
}
